module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "cdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("UN building, New York City")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Mara Duncan stared at Josh MacArthur")]), _vm._v(" on the video, watching as he answered the questions from the correspondents a few rooms away. There was no sound; the video was streaming from a security unit, wired to cover the conference room in case of emergencies. But the lack of sound was perfect: it made it easier for Mara to watch him for some answer to the riddle of why she had fallen for the guy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Because she was definitely attracted to him. Which didn’t make a lot of sense.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara swiveled in the chair. The small office was one of several backups scattered throughout the complex. Her UN security escort had ducked out to get them some lunch.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Josh was intellectual, a scientist. She was not. Not that she was dumb, by any means. Going by her grades in college, certainly, she was anything but a dope. But she preferred outdoor things like hiking and waterskiing and even parachute jumping to reading. And when she did read, it was more along the lines of a mystery or something, not a scientific treatise.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What she admired—what she loved—was the way he treated the little girl, M"), _c('span', {
    staticClass: "epub-accent-r"
  }, [_vm._v("ạ")]), _vm._v(". He’d been so tenderly attentive and fiercely protective at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He had a good smile as well. Boyish. And shoulders—she liked his shoulders, though he wasn’t a bodybuilder type.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara thought of the army officer she’d met in Vietnam—Zeus. Now there was a physical type she went for: high school quarterback, super jock, and not a dumb one, either.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Making love to him would be … interesting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Athletic.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But it’s Josh I want, Mara thought, glancing back at the video screen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her sat phone buzzed. It was Peter Lucas.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara cringed as she answered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Boss?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Mara, excellent work up there. Those Chinese assassins—dead?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Secret Service says they are. They’re singing your praises. There’ll be a commendation. Good work. Hell of a job.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I guess I don’t have to do any more penance for Malaysia, Mara thought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I watched the show. CNN, Fox, everybody’s got it. Your boy is good. Very, very good. You coached him?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Some special troubleshooter came down,” said Mara. “Jablonski. The president’s guy. He’s a political handler or something.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well, Josh was great. Very, very convincing.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How’s M"), _c('span', {
    staticClass: "epub-accent-r"
  }, [_vm._v("ạ")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The little girl is fine, as far as I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Can you send somebody to check on her?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Don’t go maternal on me, Mara. The girl isn’t my department.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m not being maternal. She has no family. I’m just looking out for her.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You did that in Vietnam, Mara. That part of your job is done.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Look, they kept her from having to go in front of the UN, right? She’s in good hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That sounds perverse.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Lucas didn’t respond. Normally his sense of humor was just as black as hers, but certain things he didn’t joke about.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“When am I going back?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Back?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Are you sending me to Vietnam, or back to Bangkok?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I don’t know yet. I was thinking…”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His voice trailed off. That was never good. Mara instantly realized the reason.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Peter, you’re not thinking of pulling me back to Langley, are you?” she said. It was more an accusation than a question. “Putting me on the desk?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ve been thinking I need some help here,” said Lucas.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“No.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara’s voice was so loud she startled herself. She glanced around the room, making sure it was empty.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No way she was going to get herself locked into an assignment at CIA headquarters as a desk sitter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s not a death sentence, for cryin’ out loud,” Lucas told her. “And it wouldn’t be permanent. Hell, a promotion would be involved. Part of your career path.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Bull.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I need someone I can trust to represent me back here. I have to get back to Bangkok. When the Chinese take Vietnam, Thailand’s going to be next.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("When")]), _vm._v(" the Chinese take Vietnam?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We’re talking days, Mara. At most. And Thailand’s next. Cambodia. Laos. The only question is which one they go after first.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara thought there were a lot of questions besides that one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What do you think?” Lucas asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m not going to be your secretary, Peter. That’s not my skill set.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I was thinking more my spear thrower.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You can’t put a good gloss on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She got up from the seat, anger stoking her adrenaline. Lucas might think of it as a promotion—maybe in some ways it was—but she deserved some consideration after everything. He ought to be asking her what she wanted to do. Dozens of people could carry water for him here. And better than she could.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Unless …")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Peter, is my cover blown?” Mara asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No,” he said, a little more slowly than she would have liked. “No. I don’t think so. Listen to me. This would be a good career move.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Staying in the field would be better.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well, think about it. You don’t have to make a decision yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s already made up.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Take your time.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m ready to go back now, Peter. I should be in Saigon. Did you find out who ripped off the money that was supposed to be at the drop?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I can’t talk about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’d like to cut his balls off.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“Mara.”")]), _vm._v(" Lucas’s voice had an exasperated tone that Mara recognized as a warning: the next thing out of his mouth would be a long speech about how much she owed him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll see you tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Take a few days off. Three or four.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll see you tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Take one day off at least.” He hung up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara sighed and turned her attention back to the screen. Josh was getting up. The interviews were finally over.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb2"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Josh followed wearily")]), _vm._v(" as Jablonski and the two bodyguards from the federal marshal’s office squeezed him down the back hallway and hurried him into a stairwell.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Where are we going now?” Josh asked as they started down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We’re going to get you some rest,” answered Jablonski. “At least a few hours. We’re setting up something with Sky News, and a BBC interview. But you should be able to do those by phone. The important things are the morning shows, and we want you better rested for that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Where’s Mara?” asked Josh.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“She’ll be along.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I wanted to talk to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jablonski started to make a face. The BlackBerry in his suit jacket rang; he reached in and took it out, glanced at the face for the caller ID, then held it to his ear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“This is William. Fred, how "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("are")]), _vm._v(" you? Glad you could get back to me.…” Jablonski stopped and glanced at Josh. “We "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("might")]), _vm._v(" be able to give the congressman a personal briefing. A short one.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Josh tensed. The earlier “personal briefing” had almost gotten him killed this morning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He doesn’t have a lot of time,” Jablonski said. He winked at Josh. “The congressman is? Well, maybe if they were seen walking together…? Hold on.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jablonski muted the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I wonder if you could do a favor,” he told Josh. “There’s a congressman from Long Island who’s going to be in a pretty hard reelection campaign. He’s a reliable vote. If we could help him…”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Like how?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Have your picture taken talking to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How will that help?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“One hand washes the other,” said Jablonski, slurping in the end of the sentence. “Don’t worry. It does.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Josh hated all this political bull. But as Jablonski had explained the other night, Congress was opposed to helping the Vietnamese. It wasn’t going to be easy to change that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“If we can get out of here when it’s done, then okay,” said Josh.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jablonski put the phone back to his ear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We’ll be down in a few minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jablonski sent a text, then put the phone away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Okay, Josh, it’s all arranged,” said Jablonski. “Let’s go.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Where’s Mara?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll tell her to meet us. Come on, let’s go.”")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb2"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A member of the federal")]), _vm._v(" marshal’s detail was waiting as Mara stepped off the elevator into the garage below the UN building.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They just changed plans,” he said. “Mr. Jablonski told the cars to meet them on the street at the back.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“On the street? That makes no sense.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The marshal shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Somebody tried to kill him this morning,” said Mara. “He has to be protected.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The whole area’s sealed off,” said the marshal.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You can’t think this is a good idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What do you want me to tell you? I’m just following orders. There’s tons of security around, ma’am. Tons.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara hated when anyone called her ma’am.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Just take me to wherever the hell they are.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The marshal turned and walked across the smooth concrete of the underground parking garage. A few hours before, the place had been swarming with Secret Service men, some of them armed with submachine guns. But that was mostly because the President was here. Now the only security people she could spot were a pair of New York City policemen standing at the far end of garage, near the ramp to street level.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But maybe that made sense. The Chinese wouldn’t kill Josh now; that would just prove his point. They would create a martyr.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She followed the marshal back up the stairs to the first floor, then out into the main lobby. There were a dozen photographers and several video crews crowded near the door. They glanced in her direction, then realized she was nobody and went back to waiting, hoping to get a look at Josh as he left.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The marshal led her through the throng to a section of roped-off elevators. They went up a flight, then out and across the hall to a staircase at the back of the building. These led to the long hallway flanking the General Assembly Chamber. Television lights flooded the space, glaring off the art displayed along the temporary wall at Mara’s left. Diplomats were clustered at the far end, listening to someone give an impromptu news interview.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was Josh. His voice, soft, tired, echoed through the hall. He was talking about Vietnam, what he had seen there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As Mara approached the back of the crowd, it began to move. A uniformed security guard glanced at her as she approached, then turned back, spotting the "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("UN VIP")]), _vm._v(" identification tag hanging around her neck. Mara followed along, not wanting to draw any attention to herself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The procession grew as they pushed outside, swelling as reporters who’d missed the impromptu interview inside realized from the commotion that they would have another chance. A few shouted questions from the side. Mara spotted Jablonski guiding Josh around the side of the building, toward a pair of Lincoln town cars. A line of NYPD officers blocked the cars from the rest of the lot; as the reporters realized they were about to be cut off, they swarmed around, temporarily blocking the way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Josh stopped and raised his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“All right, I’ll take questions. Whatever you want.” His voice was hoarse. It sounded as tired as the first night she’d found him in Vietnam.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We only have a few minutes,” said Jablonski. Mara couldn’t quite see his head through the crowd. “Then Mr. MacArthur has to brief Congressman Joyce. I’m sure you understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The reporters started asking questions, the same ones Josh had been fielding for hours:")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("What were you doing in Vietnam?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("How did you escape?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("How did you get the images?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Was anyone left alive?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He answered wearily, but patiently. His answers were getting shorter and shorter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Poor guy, thought Mara. He was exhausted. Couldn’t they see that?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara sidled around the edge of the crowd, moving to position herself closer to the line of policemen, trying to catch Jablonski’s eye. Her escort had disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The back door of the second town car opened. A tall, thin man with slicked-back gray hair unfolded himself from the interior, popping up like the inside of birthday card. He had his jacket off, white shirtsleeves rolled up, and tie fluttering in the wind as he strode forward.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was a congressman or some other politician, Mara realized. One more episode in Jablonski’s dog-and-pony show, designed to please friends and to influence enemies.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She slipped behind a cameraman, pushing gently toward Josh and Jablonski. But the policemen nearest her pivoted, forming a wedge as the congressman approached. They were in her way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deciding it would be easier to go around to the other side of the scrum, Mara backed out, squeezing between two latecomers. Walking along the edge of the crowd, she looked for the marshal who’d accompanied her earlier. There were a few people standing around, employees she guessed, watching the proceedings. One or two smoked cigarettes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A silver Lexus LX 470 pulled up near the entrance. Someone got out—a young Asian woman. She was dressed in a flower-print pink skirt, knee-length, with a tightly tailored business jacket. Her long hair was tied at the back. She wore glasses, but these softened her features, making her look interested rather than studious.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She waved her credentials at one of the police officers, and gestured back toward the main security post by the street. Meanwhile a young man in jeans and a blue blazer got out of the other side of the car, from the front seat, and hustled after her, carrying a video camera. The policeman waved her past.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara looked at the car. The windows were blacked out. What television news service drove around in a Lexus?")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb2"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Josh did his best")]), _vm._v(" not to grimace as the congressman talked about the heinous crimes to mankind, naked aggression, and the need for immediate congressional hearings to determine the proper course of action.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We don’t need hearings,” muttered Josh.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jablonski poked him gently in the ribs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What about hearings?” asked one of the reporters nearby.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He said they need them,” said another.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We don’t need them. The Chinese need to stop their attacks,” said Josh in frustration.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The congressman turned to glare at him. For a just a moment his eyes narrowed into daggers. Josh wouldn’t have been surprised if a laser beam shot from them and burned away his tongue. He didn’t care.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Our scientist friend is right,” said the congressman, the glare replaced by a fresh smile. “Action. Hopefully my colleagues in Congress will see it that way. Now, come on, I know you have several appointments. We’ll talk on the way.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jablonski took hold of Josh’s arm. Josh looked over the crowd and saw Mara twenty or thirty feet away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Mara!” he yelled, resisting Jablonski’s soft pull. “Mara!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He waved. Jablonski stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s Mara,” Josh told him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jablonski turned to one of the marshals. The marshal nodded, then went to get Mara. She was already walking toward them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You are a liar, Mr. MacArthur!” shouted a voice from the crowd. “I don’t know how you sleep at night!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Josh stopped short. The accusation felt like a physical blow to the back of his neck.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What? What?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Those photos we see—aren’t they made up?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Josh couldn’t see the woman who was making the accusation. Where was she?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Why would I make that up?” said Josh. He wasn’t even sure who he was answering.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The reporters nearest Josh stepped aside to reveal a young Asian-looking woman with glasses—the one Mara had seen getting out of the car. She had a pad in her hand; her videographer was filming over her shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Where did you get the photos?” the woman asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“In Vietnam. Northern Vietnam.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Where precisely?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her voice was sweet, not shrill. Now that she was close, she spoke almost softly. Her English had a slight accent—Chinese, Josh thought, though he couldn’t really be sure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It was near the border,” said Josh. “We had established a camp—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s okay, Josh. She’s trying to provoke you,” whispered Jablonski in his ear. “She’s probably some sort of spy. Let’s go.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I didn’t make anything up,” said Josh. “We were north of a place called Ba Sin Sui Ho. I may not be pronouncing it right. We were studying climate change, its effects on the jungle and the life there.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s all right, Josh,” repeated Jablonski. “Come on. Mara’s here. Let’s go.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m not lying,” he told Jablonski.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They’re trying to provoke you. Don’t let them.” Jablonksi looked up at the reporters. “You have all the data on the images and the approximate location of the massacre,” he said loudly. “You can download all of the information off the State Department Web site.”")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb2"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Josh was trembling")]), _vm._v(" as he got into the car.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“She called me a liar,” he said as Mara slipped in next to him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I wouldn’t worry about it, son,” said Congressman Joyce on the other side of Josh. “These reporters—they spout bull just to get your reaction.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I doubt that was a reporter,” said Jablonski, who’d gotten into the front. “Probably a Chinese spy.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He leaned over the seat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Can you check on it?” he asked Mara.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sure,” she said, wishing he hadn’t said anything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I think it went very well, all things considered,” said the congressman. He slapped Josh on the knee, then looked across to Mara. “And you are…?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Mara Duncan.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I take it you’re with the FBI?” He glanced at Jablonski.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“State Department,” said Jablonski. “She’s our liaison.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Good, very good,” said the congressman, sitting back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mara looked at Josh. He was sweating, and staring at her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I don’t think it’s a big deal,” Mara told him. “Relax.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I know what I saw. I was right there. We were right there.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I know you did, Josh,” said Mara. “Don’t worry.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-578040e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter6.vue
// module id = 101
// module chunks = 0